<template>
	<el-card shadow="never" class="aui-card--fill">
		<el-row style="background-color: #F3F4F4;">
			<el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
				<img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/user-list.png" />
				我发布的任务
			</el-col>
			<el-col :xs="24" :md="18">
				<el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" style="text-align: right;">
					<el-form-item>
						<el-button v-no-more-click v-if="$hasPermission('plat:plattask:save')" type="primary" @click="childHandle()">发布新任务</el-button>
					</el-form-item>
					<el-form-item>
						<el-button class="exportBtn" style="left: 615px;" v-if="$hasPermission('plat:plattask:export')" type="info" @click="exportHandle()">
							{{ $t('export') }}
						</el-button>
					</el-form-item>
					<el-form-item><el-button class="refreshBtn" style="left: 500px;" type="info" @click="getDataList()">刷新</el-button></el-form-item>
					<el-form-item>
						<el-button class="delBtn" style="left: 760px;" v-if="$hasPermission('plat:plattask:delete')" type="danger" @click="deleteHandle()">
							{{ $t('deleteBatch') }}
						</el-button>
					</el-form-item>
				</el-form>
			</el-col>
		</el-row>

		<div class="mod-plat__plattask}">

			<el-table v-loading="dataListLoading" :data="dataList" @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
				<el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
				<el-table-column label="序号" type="index" width="50" align="center">
					<template slot-scope="scope">
						<span>{{ (page - 1) * limit + scope.$index + 1 }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="taskCode" label="任务发布编号" header-align="center" align="center" show-overflow-tooltip></el-table-column>

				<el-table-column prop="publishName" label="发布方" header-align="center" align="center" show-overflow-tooltip></el-table-column>

				<el-table-column prop="taskType" label="任务大类" header-align="center" align="center">
					<template slot-scope="scope">
						{{ $getDictLabel('taskType', scope.row.taskType) }}
					</template>
				</el-table-column>
				<el-table-column prop="budget" label="预算金额(元)" header-align="center" align="center"></el-table-column>
				<el-table-column prop="contractCode" label="合同编号" header-align="center" align="center">
					<template slot-scope="scope">
						<el-button style="word-break: break-all;white-space: wrap;" type="text" size="small" @click="contractinfoHandle(scope.row.contractId)">{{scope.row.contractCode}}</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="requirePerson" label="需求人数" header-align="center" align="center">
				</el-table-column>
				<el-table-column prop="startDate" label="任务周期" header-align="center" align="center">
					<template slot-scope="scope">
						<span>{{getTimeRange(scope.row.startDate,scope.row.endDate)}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="createDate" label="发布时间" header-align="center" align="center"></el-table-column>
				<el-table-column prop="status" label="审核状态" header-align="center" align="center">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.status == 0" size="small" type="danger">待提交
						</el-tag>
						<el-tag v-if="scope.row.status == 1" size="small" type="warning">待审核
						</el-tag>
						<el-tag v-if="scope.row.status ==2" size="small" type="success">已审核
						</el-tag>

						<el-tag v-if="scope.row.status == 3" size="small" type="info">已关闭
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
					<template slot-scope="scope">
						<el-tooltip class="item" effect="dark" content="只有草稿状态才可修改。如已提交发布，请先进行驳回操作！" placement="left">
							<span>
								<el-button
									v-if="$hasPermission('plat:plattask:update')"
									:disabled="scope.row.status != '0'"
									type="text"
									size="small"
									@click="childHandle(scope.row.id)"
								>
									{{ $t('update') }}
								</el-button>
							</span>
						</el-tooltip>
						<el-button type="text" size="small" @click="infoHandle(scope.row.id)">详情</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				:current-page="page"
				:page-sizes="[10, 20, 50, 100]"
				:page-size="limit"
				:total="total"
				layout="total, sizes, prev, pager, next, jumper"
				@size-change="pageSizeChangeHandle"
				@current-change="pageCurrentChangeHandle"
			></el-pagination>
			<!-- 弹窗, 新增 / 修改 -->
			<add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
		</div>
	</el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from '../plat/plattask-add-or-update'
import { addDynamicRoute } from '@/router'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      deputyInfoVisible: false,
      mixinViewModuleOptions: {
        getDataListURL: '/sys/plat/task/page',
        getDataListIsPage: true,
        deleteURL: '/sys/plat/task',
        deleteIsBatch: true,
        exportURL: '/sys/plat/task/export3'
      },
      daterange: null,
      options: []
    }
  },
  components: {
    AddOrUpdate
  },
  watch: {
  },
  created () {
    this.getContract()
  },
  methods: {
    getContract () {
      this.$http
        .get(`/sys/plat/contract/getContractCodeList`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.options = res.data
        })
        .catch(() => {})
    },
    // 查看
    infoHandle (id) {
      // 路由参数
      const routeParams = {
        routeName: `${this.$route.name}__任务详情`,
        title: `任务详情`,
        path: 'plat/platttask-info',
        params: {
          id: id
        }
      }
      // 动态路由
      addDynamicRoute(routeParams, this.$router)
    },
    childHandle (id = 0) {
		  // 路由参数
		  const routeParams = {
        routeName: `${this.$route.name}__任务信息`,
        title: `任务信息`,
        path: 'plat/platttask-add',
        params: {
			  id: id
        }
		  }
		  // 动态路由
		  addDynamicRoute(routeParams, this.$router)
    },

    // 查看
    contractinfoHandle (id) {
      // 路由参数
      const routeParams = {
        routeName: `${this.$route.name}__合同详情`,
        title: `合同详情`,
        path: 'plat/platcontract-info',
        params: {
						  id: id
        }
      }
      // 动态路由
      addDynamicRoute(routeParams, this.$router)
    },
    ticketApplyinfoHandle (id) {
      // 路由参数
      const routeParams = {
        routeName: `${this.$route.name}__开票申请详情`,
        title: `开票申请详情`,
        path: 'plat/platinvoicingtasklist-add',
        params: {
						  id: id,
						  url: '/sys/plat/platticketrecord/apply-page-data/'
        }
      }
      // 动态路由
      addDynamicRoute(routeParams, this.$router)
    },
    dealinfoHandle (id) {
      // 路由参数
      const routeParams = {
        routeName: `${this.$route.name}__结算申请详情`,
        title: `结算申请详情`,
        path: 'plat/platapply-approval',
        params: {
          id: id,
          typedata: 2
        }
      }
      // 动态路由
      addDynamicRoute(routeParams, this.$router)
    },
	getTimeRange(startDate,endDate){
		if(!startDate || !endDate){
			return ''
		}
		let sDate = startDate.replace(/-/g,'.');
		let eDate = endDate.replace(/-/g,'.');
		return `${sDate}-${eDate}`;
	}
  }
}
</script>
<style>
.item {
	margin: 4px;
}
</style>
